import Vue from 'vue'
import { DealService} from '@/common/api.service'

import {
    FETCH_DEAL,
    FETCH_DEALS,
    DEAL_RESET_STATE,
    FETCH_DEALS_BY_CLIENT,
    FETCH_DEALS_BY_MONTH
} from './actions.type'

import {
    SET_DEALS,
    SET_DEAL,
    SET_DEALS_BY_CLIENT,
    SET_DEALS_BY_MONTH,
    RESET_STATE,
} from './mutations.type'

const initialState = {
    deal: {},
    deals: [],
    dealsTotalCount: 0 ,
    dealsByClient: [],
    dealsByClientTotalCount: 0,
    dealsByMonth: []
}

export const state = Object.assign({}, initialState)

export const actions = {
    [FETCH_DEAL] (context, payload) {
        return DealService.get(payload.id)
        .then(({ data }) => {
            context.commit(SET_DEAL, data)
            return data
        })
    },
    [FETCH_DEALS] (context, payload) {
        return DealService.getWithFilter(payload.filter)
        .then(({ data }) => {
            context.commit(SET_DEALS, data)
            return data
        })
    },
    [FETCH_DEALS_BY_CLIENT] (context, payload) {
        return DealService.getDealsByClientWithFilter(payload.filter)
        .then(({ data }) => {
            context.commit(SET_DEALS_BY_CLIENT, data)
            return data
        })
    },
    [FETCH_DEALS_BY_MONTH] (context, payload) {
        return DealService.getDealsByMonthWithFilter(payload.filter)
        .then(({ data }) => {
            context.commit(SET_DEALS_BY_MONTH, data)
            return data
        })
    },
    [DEAL_RESET_STATE] ({ commit }) {
        commit(RESET_STATE)
    }
}

export const mutations = {
    [SET_DEALS] (state, deals) {
        state.deals = deals.data;
        state.dealsTotalCount = deals.totalRows;
    },
    [SET_DEALS_BY_CLIENT] (state, deals) {
        state.dealsByClient = deals.data;
        state.dealsByClientTotalCount = deals.totalRows;
    },
    [SET_DEAL] (state, deal) {
        state.deal = deal
    },
    [SET_DEALS_BY_MONTH] (state, deals) {
        state.dealsByMonth = deals;
    },
    [RESET_STATE] () {
        for (let f in state) {
          Vue.set(state, f, initialState[f])
        }
    }
}

const getters = {
    deals (state) {
      return state.deals
    },
    dealsByClient(state){
        return state.dealsByClient
    },
    deal (state) {
        return state.deal
    },
    dealsTotalCount (state) {
        return state.dealsTotalCount
    },
    dealsByClientTotalCount (state) {
        return state.dealsByClientTotalCount
    },
    dealsByMonth (state) {
        return state.dealsByMonth
    }
  }

export default {
    state,
    actions,
    mutations,
    getters
}